export const TRANSLATION_LOCALE_KEY = "i18n-locale";
export const TRANSLATION_KEY = "i18n-translations";
